"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const flexStart = 'flex-start';
const flexEnd = 'flex-end';
const flexCenter = 'center';
const between = 'space-between';
const around = 'space-around';
exports.default = ({ top, middle, bottom, left, center, right, spaceBetween, spaceAround, isVertical, }) => {
    let xAxis = 'initial';
    let yAxis = 'initial';
    // does the xAxis have any values
    if (left || center || right || spaceBetween || spaceAround) {
        if (left) {
            xAxis = flexStart;
        }
        else if (center) {
            xAxis = flexCenter;
        }
        else if (right) {
            xAxis = flexEnd;
        }
        else if (spaceBetween) {
            xAxis = between;
        }
        else if (spaceAround) {
            xAxis = around;
        }
    }
    // does the yAxis have any values?
    if (top || middle || bottom) {
        if (top) {
            yAxis = flexStart;
        }
        else if (middle) {
            yAxis = flexCenter;
        }
        else if (bottom) {
            yAxis = flexEnd;
        }
    }
    if (isVertical) {
        if (left || center || right) {
            if (left) {
                xAxis = flexStart;
            }
            else if (center) {
                xAxis = flexCenter;
            }
            else if (right) {
                xAxis = flexEnd;
            }
        }
        if (top || middle || bottom || spaceBetween || spaceAround) {
            if (top) {
                yAxis = flexStart;
            }
            else if (middle) {
                yAxis = flexCenter;
            }
            else if (bottom) {
                yAxis = flexEnd;
            }
            else if (spaceBetween) {
                yAxis = between;
            }
            else if (spaceAround) {
                yAxis = around;
            }
        }
    }
    return {
        justifyContent: xAxis,
        alignItems: yAxis,
    };
};
